import { newTheme } from './NewTheme'

const defaultColors = {
  PRIMARY: '#2469FF',
  SECONDARY: '#2469FF',
  PRIMARY_STORNG: '#003099',
  WHITE: '#FFFFFF',
  SECONDARY_LIGHT: 'rgba(255,255,255,0.7)',
  BLACK: '#000000',
  ERROR: '#D0021B',
  SECONDARY_GREY: '#A8A8A8',
  PRIMARY_GREY: '#757575',
  LIGHT_GREY: '#959595',
  DARK_GREY: '#555555',
  GREEN: '#4FAF49',
  TEAL: '#00B6B6',
  BLUE_TANCENT: 'rgb(55,181,232)',
  BACKGROUND: '#F8F8F8',
  GREY_SEPARATOR: '#F0F0F0',
  ORANGE: '#FF9E00',
  BORDER_COLOR: '#DEDEDE',
  BLUE_SHADE: '#007dc5',
  TINY_GREY: '#9E9E9E',
  WHITE_SEPERATOR: '#FFFFFF1A',
  ALTO_DISABLED: 'rgba(216, 216, 216, 0.1)',
  BLACK_LIGHT: '#00000050',
  TRANSPARENT: '#00000000',
  WHITE_30: 'rgba(255, 255, 255, 0.3)',
  BLACK_75: 'rgba(0, 0, 0, 0.75)',
  BLACK_STRIKE: '#555555',
  HOTEL_PRIMARY: '#555555',
  HOTEL_PRIMARY_TRANSPARENT: '#5555554C',
  YELLOW: '#FFB900',
  TRANSPARENT45: 'rgba(0, 0, 0, 0.45)',
  RED: '#FF0000',
  BLUE_MAP: '#0C2B69',
  WHITE45: 'rgba(255, 255, 255, 0.45)',
  WHITE50: '#FFFFFF80',
  WHITE80: 'rgba(255, 255, 255, 0.80)',
  WHITE4: 'rgba(255, 255, 255, 0.04)',
  VERY_LIGHT_GREY: '#32424242',
  INACTIVE_GREY: '#555555',
  WHITE30: 'rgba(255, 255, 255, 0.3)',
  PURE_BLACK: '#000000',
  SEPERATOR: '#D8D8D8',
  ITEM_SEPARATOR: '#DDDDDD',
  GRAY_HALF: '#F7F7F7',
  BLACK_GRAY_SHADE: '#323232',
  GREY_1_SEPARATOR: '#D7D7D7',
  PRIMARY_LIGHT_GREY: '#F6F6F6',
  LIGHT_GREY_SEPARATOR: '#FAFAFA',
  LIGHT_GREY_INTRO: '#BDBDBD',
  BLACK_SECONDARY: '#323232',
  LIGHT_BLUE_SEPARATOR: '#3759A0',
  GRAY_BORDER: '#00000014',
  DISABLED_GREY: '#E0E0E0',
  BLACK_21: '#212121',
  GRAY_SHADOW: '#00000029',
  LIGHT_BLACK: '#7F7F7F',
  TEST_MODE: '#e68c32',
  LIVE_MODE: '#11c13a',
  LIGHTEST_GREY: '#EFEFEF',
  LIGHTEST_GREY_2: '#F2F2F2',
  MEDIUM_GREY: '#6A6A6A',
  DARK_GREY_2: '#222222',
  MODAL_BG: '#000000bb',
  MODAL_UNDERLAY: '#000000cc',
  GREY_WHITE: '#2247970F',
  GRAY_LIGHT: '#00000061',
  DARK_BLUE: '#224797',
  WHITE_DIM: '#FFFFFF8A',
  BACKGROUND_LIGHT: '#EEEEEE',

  HAZY_GREEN: '#25D782',
  GREYISH_WHITE: '#F9F9F9',
  DARK_GREY_BORDER: '#E3E3E3',
  LEAF_GREEN: '#90EE90',
  SHADOW_GREY: '#AAAAAA',
  PENCIL_GREY: '#383838',
  NUKE_GREEN: '#31D088',
  AVAILABLE_GREEN: '#2CA200',
  SHADOW_LIGHT_GREY: '#D8D8D84D',
  SHACK_PURPLE: 'rgb(134, 65, 244)',
  BRIGHT_SKY: 'rgb(66, 194, 244)',
  SHADED_GREY: '#949596',
  COMING_BLACK: '#313233',
  DARK_OCEAN_BLUE: '#224896',
  OCEAN_BLUE_LIGHT: '#647FB5',
  VISIBLE_WHITE: '#F4F4F4',
  CLOUDY_GREY: '#A5A5A5',
  GREY_MATTE: '#C7C7C7',
  DISMANTLED_GREEN: '#25D78227',
  HEXA_PURPLE: '#1E4498',
  BLUE: '#0186B0',
  BLUE_SHADE_PRIMARY: '#0070B6',
  GREY_BORDER_ALPHA: 'rgba(240, 240, 240, 0.4)',
  GRADIENT_ORANGE_FADE: 'linear-gradient(to right, rgba(244, 215, 165, 1) 0%, rgba(244, 215, 165, 0.9), rgba(244, 215, 165, 0.8), rgba(244, 215, 165, 0.7), rgba(244, 215, 165, 0.6), rgba(244, 215, 165, 0.5), rgba(244, 215, 165, 0.4), rgba(244, 215, 165, 0.3), rgba(244, 215, 165, 0.2), rgba(244, 215, 165, 0.1), rgba(244, 215, 165, 0) 100%)',

  ...newTheme.colors,
}

const defaultFontSizes = {
  FONT_SIZE_VERY_SMALL: 9,
  FONT_SIZE_SMALLER: 11,
  FONT_SIZE_TINY: 10,
  FONT_SIZE_SMALL: 12,
  FONT_SIZE_MEDIUM: 14,
  FONT_SIZE_LARGE: 16,
  FONT_SIZE_LARGE_PLUS: 18,
  FONT_SIZE_DOUBLE_LARGE: 20,
  FONT_SIZE_LARGE_2P: 18,
  FONT_SIZE_LARGE_3P: 20,
  FONT_SIZE_EXTRA_LARGE: 24,
  FONT_SIZE_2_EXTRA_LARGE: 30,
  FONT_SIZE_EXTRA_LARGE_PLUS: 32,
  FONT_SIZE_EXTRA_LONG: 36,
  ...newTheme.fontSizes,
}

const defaultFontWeights = {
  FONT_WEIGHT_LIGHT: 300,
  FONT_WEIGHT_MEDIUM: 'normal',
  FONT_WEIGHT_BOLD: 700,
  ...newTheme.fontWeights,
}

const defaultSpace = {
  TINY: 4,
  SMALLEST: 8,
  SMALL: 12,
  MEDIUM: 16,
  MEDIUM_BIG: 20,
  LARGE: 16,
  BIG: 24,
  BIGGER: 28,
  HUGE: 32,
}

const defaultSizes = {
  ZERO: 0,
  ONE: 1,
  TINY: 8,
  SMALLEST: 16,
  SMALL: 24,
  MEDIUM: 36,
  MEDIUM_2: 48,
  MEDIUM_BIG: 56,
  BIG: 64,
  BIGGER: 128,
  HUGE: 196,
} as any

const defaultBorderWidths = {
  NORMAL: 1,
  THICK: 2,
}

const defaultRadii = {
  SMALL: 4,
  MEDIUM: 8,
  BIG: 16,
}

const defaultOpacities = {
  FAINT: 0.2,
  MEDIUM: 0.5,
  DARK: 0.8,
}

const defaultFonts = {
  JioMoney: 'JioMoney',
}

const defaultTheme = {
  colors: defaultColors,
  fontSizes: defaultFontSizes,
  fontWeights: defaultFontWeights,
  space: defaultSpace,
  sizes: defaultSizes,
  borderWidths: defaultBorderWidths,
  radii: defaultRadii,
  opacities: defaultOpacities,
  fonts: defaultFonts,
  lineHeights: newTheme.lineHeights,
  breakpoints: [480, 720, 1080],
}

export {
  defaultTheme,
  defaultColors,
  defaultFontSizes,
  defaultFontWeights,
  defaultSpace,
  defaultSizes,
  defaultBorderWidths,
  defaultRadii,
  defaultOpacities,
  defaultFonts,
}
